import React, { lazy, Suspense } from "react";
import "./App.scss";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import OutletSkeleton from "./skeletons/OutletSkeleton";
import Cancellation from "./pages/Cancellation";
import CancellationStatus from "./pages/CancellationStatus";
import ModifyBooking from "./pages/ModifyBooking";
import ModifyBookingStatus from "./pages/ModifyBookingStatus";
import Registration from "./pages/registration/Registration";
import PreviewPage from "./pages/registration/PreviewPage";

// Import lazy loading components
const HomePage = lazy(() => import("./pages/HomePage"));
const SummaryPage = lazy(() => import("./pages/Summary"));
const ExtendCheckout = lazy(() => import("./pages/ExtendCheckout"));
const AllOutlets = lazy(() => import("./pages/AllOutlets"));
const Addons = lazy(() => import("./pages/Addons"));
const CheckoutSummary = lazy(() => import("./pages/CheckoutSummary"));
const FrontDeskKiosk = lazy(() => import("./pages/FrontDeskKiosk"));
const SearchReservation = lazy(() => import("./pages/SearchReservation"));
const GuestRooms = lazy(() => import("./pages/GuestRooms"));
const GuestAddEdit = lazy(() => import("./pages/GuestAddEdit"));

const CurrentRoom = lazy(() => import("./pages/CurrentRoom"));
const AvailableRooms = lazy(() => import("./pages/AvailableRooms"));
const EarlyCheckin = lazy(() => import("./pages/EarlyCheckin"));
const BookingConfirmation = lazy(() => import("./pages/BookingConfirmation"));
const BookingFailure = lazy(() => import("./pages/BookingFailure"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<OutletSkeleton />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/" element={<SfLoader />} /> */}
          <Route
            path="/front-desk-kiosk/:hotelId"
            element={<FrontDeskKiosk />}
          />
          <Route
            path="/search-reservation/:hotelId"
            element={<SearchReservation />}
          />
          <Route path="/:bookingSuffix/:bookingHash" element={<HomePage />} />
          <Route path="/guest-rooms" element={<GuestRooms />} />
          <Route path="/update-guest" element={<GuestAddEdit />} />
          <Route path="/self-room-upgrade" element={<CurrentRoom />} />
          <Route
            path="/self-room-upgrade-available/:reservationId"
            element={<AvailableRooms />}
          />
          <Route path="/early-checkin" element={<EarlyCheckin />} />
          <Route path="/extend-checkout" element={<ExtendCheckout />} />
          <Route path="/all-outlets" element={<AllOutlets />} />
          <Route path="/addons/:outletId" element={<Addons />} />
          <Route path="/checkout-summary" element={<CheckoutSummary />} />
          <Route path="/summary" element={<SummaryPage />} />
          <Route path="/cancellation" element={<Cancellation />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/cancellation-status" element={<CancellationStatus />} />
          <Route path="/modify-booking" element={<ModifyBooking />} />
          <Route path="/modify-status" element={<ModifyBookingStatus />} />
          <Route path="/reg-preview" element={<PreviewPage />} />

          <Route
            path="/cartSuccessConfirmation/:bookingId"
            element={<BookingConfirmation />}
          />
          <Route
            path="/booking-failure/:reasonCode"
            element={<BookingFailure />}
          />

          <Route path="*" element={<HomePage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
